interface Props { cs: boolean }

function CsBody() {
  return (
    <>
      <p>
        ShowX je navržen pro práci více operátorů najednou. SM na FOH Macu řídí show, LX operátor sleduje svůj
        pohled na iPadu, SX operátor na notebooku. Každý vidí jen to, co se ho týká — ale všichni sdílejí jeden
        živý show dokument přes Yjs CRDT.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">GO authority — kdo smí GO</h3>
      <p>
        Každý cuelist má nastavení <code>go_authority</code>, které určuje, kdo může spustit cue:
      </p>
      <ul>
        <li>
          <strong>sm_called</strong> (výchozí) — pouze SM stanice. Ostatní stanice pošlou "potvrdit" zprávu, ale
          GO vydá jen SM. Typické pro divadelní produkce s voláním cues.
        </li>
        <li>
          <strong>auto_cascade</strong> — první platný GO z jakékoli stanice se kaskáduje na všechny departementy.
          Vhodné pro firemní produkce, kde každý operátor kontroluje vlastní sekci.
        </li>
        <li>
          <strong>per_dept</strong> — každý department má vlastní GO autoritu. LX operátor spouští LX cues, SX
          operátor SX cues. SM nezasahuje.
        </li>
        <li>
          <strong>timecode</strong> — GO spouští pouze timecode (LTC/MTC). SM GO funguje jako manuální přepsání.
          Post-MVP trigger druh (zatím v plánu pro 0.2).
        </li>
      </ul>
      <p>
        Pokud stanice zkusí GO a nemá autoritu, zobrazí se toast "Not authorised — SM only" nebo podobně. GO se
        neprovede, žádná eskalace — SM je vyzván vizuálně.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">Per-department pohledy</h3>
      <p>
        Každá spárovaná stanice má nastaveno <strong>owned_departments</strong> a <strong>watched_departments</strong>.
      </p>
      <ul>
        <li>
          <strong>Owned</strong> — departementy, za které operátor zodpovídá a jejichž payloady spravuje.
          V pohledu jsou zvýrazněny.
        </li>
        <li>
          <strong>Watched</strong> — departementy, které operátor sleduje, ale neřídí. Cues jsou viditelné,
          ale payloady jsou ztlumeny.
        </li>
        <li>
          Cue je <strong>viditelný</strong>, pokud department cue ∩ (owned ∪ watched) ≠ ∅.
        </li>
        <li>
          Cue je <strong>akční</strong> (operátor může GO), pokud department cue ∩ owned ≠ ∅.
        </li>
      </ul>
      <p>
        Typická konfigurace: SM iPad — owned: [SM], watched: [vše ostatní]. LX pult — owned: [LX], watched: [SM].
        Sólový operátor na malém eventu — owned: [LX, SX, VIDEO], watched: [SM].
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">Compound cues — jeden řádek, více departementů</h3>
      <p>
        Cue může patřit více departementům najednou — např. "Dveřní slam" s{' '}
        <code>department=["SX","LX"]</code>. SX operátor vidí OSC payload zvýrazněný, LX payload ztlumený. LX
        operátor naopak. SM vidí oboje.
      </p>
      <p>
        Výhoda: jeden řádek v cuelistu místo dvou zrcadlových cues. Oba operátoři ví, co se děje vedle jejich
        pracovní sekce.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">SM offline policy</h3>
      <p>
        Co se stane, když SM stanice se odpojí uprostřed show? Cuelist nastavuje{' '}
        <code>sm_offline_policy</code>:
      </p>
      <ul>
        <li>
          <strong>freeze</strong> — show se zastaví. Žádné GO, dokud se SM nevrátí. Bezpečné pro kritické
          produkce.
        </li>
        <li>
          <strong>delegate</strong> — GO autorita se přesune na jiného operátora (jménem nastaveného v konfiguraci).
          Produkce pokračuje bez přerušení.
        </li>
        <li>
          <strong>auto_continue</strong> — cues se spouštějí samy podle triggeru (auto_follow/auto_continue).
          Vhodné pro plně časovanou show.
        </li>
      </ul>
      <p>
        Výchozí nastavení je <code>freeze</code>. Změnu proveď v cuelists konfiguraci show souboru.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">Calling text — standby note</h3>
      <p>
        Každý cue může mít <code>standby_note</code> — text, který SM čte na comms před spuštěním cue.
        Například: "Standby LX Q11 a SX Q5". Text se zobrazí v SM pohledu jako prominentní žlutý řádek nad
        standby cue.
      </p>
      <p>
        Standby note se volitelně edituje v CueEdit dialogu (REHEARSAL mód). V SHOW módu je editace povolena
        i bez proposals (je to textový popis, ne konfigurace payloadu).
      </p>
    </>
  )
}

function EnBody() {
  return (
    <>
      <p>
        ShowX is built for multi-operator work. SM on the FOH Mac runs the show, LX operator watches their view
        on an iPad, SX operator on a laptop. Everyone sees only what concerns them — but all share one live show
        document over Yjs CRDT.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">GO authority — who can fire</h3>
      <p>
        Every cuelist has a <code>go_authority</code> setting that determines who can fire cues:
      </p>
      <ul>
        <li>
          <strong>sm_called</strong> (default) — only the SM station. Other stations send "confirm" messages, but
          only SM issues GO. Typical for theatrical productions with called cues.
        </li>
        <li>
          <strong>auto_cascade</strong> — the first valid GO from any station cascades to all departments.
          Suitable for corporate events where each operator controls their own section.
        </li>
        <li>
          <strong>per_dept</strong> — each department has its own GO authority. LX operator fires LX cues, SX
          operator fires SX cues. SM doesn't intervene.
        </li>
        <li>
          <strong>timecode</strong> — GO only fires from timecode (LTC/MTC). SM GO acts as manual override.
          Post-MVP trigger type (planned for 0.2).
        </li>
      </ul>
      <p>
        If a station tries GO without authority, a toast appears: "Not authorised — SM only" or similar. GO is
        not executed, no escalation — SM is notified visually.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">Per-department views</h3>
      <p>
        Every paired station has <strong>owned_departments</strong> and <strong>watched_departments</strong> configured.
      </p>
      <ul>
        <li>
          <strong>Owned</strong> — departments this operator is responsible for and whose payloads they manage.
          Highlighted in the view.
        </li>
        <li>
          <strong>Watched</strong> — departments this operator monitors but doesn't control. Cues are visible,
          but payloads are dimmed.
        </li>
        <li>
          A cue is <strong>visible</strong> if cue.department ∩ (owned ∪ watched) ≠ ∅.
        </li>
        <li>
          A cue is <strong>actionable</strong> (operator can GO) if cue.department ∩ owned ≠ ∅.
        </li>
      </ul>
      <p>
        Typical setup: SM iPad — owned: [SM], watched: [everything else]. LX desk — owned: [LX], watched: [SM].
        Solo operator at a small event — owned: [LX, SX, VIDEO], watched: [SM].
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">Compound cues — one row, multiple departments</h3>
      <p>
        A cue can belong to multiple departments at once — e.g. "Door slam" with{' '}
        <code>department=["SX","LX"]</code>. SX operator sees OSC payload highlighted, LX payload dimmed. LX
        operator sees the reverse. SM sees both.
      </p>
      <p>
        Benefit: one row in the cuelist instead of two mirror cues. Both operators know what fires alongside
        their section.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">SM offline policy</h3>
      <p>
        What happens when the SM station disconnects mid-show? The cuelist sets{' '}
        <code>sm_offline_policy</code>:
      </p>
      <ul>
        <li>
          <strong>freeze</strong> — show pauses. No GO until SM returns. Safe for critical productions.
        </li>
        <li>
          <strong>delegate</strong> — GO authority moves to another operator (named in the config). Production
          continues without interruption.
        </li>
        <li>
          <strong>auto_continue</strong> — cues fire automatically on trigger (auto_follow/auto_continue).
          Suitable for a fully timed show.
        </li>
      </ul>
      <p>
        Default is <code>freeze</code>. Change this in the cuelist configuration of the show file.
      </p>

      <h3 className="display-serif text-xl mt-10 mb-3">Calling text — standby note</h3>
      <p>
        Each cue can have a <code>standby_note</code> — text the SM reads on comms before firing the cue.
        For example: "Standby LX Q11 and SX Q5". The text appears as a prominent yellow line above the standby
        cue in SM view.
      </p>
      <p>
        The standby note is optionally edited in the CueEdit dialog (REHEARSAL mode). In SHOW mode, editing is
        allowed without proposals (it is a descriptive text, not a payload configuration).
      </p>
    </>
  )
}

export default function Chapter6({ cs }: Props) {
  return (
    <article id="kap-6" className="scroll-mt-24">
      <h2 className="display-serif text-display-2 leading-tight mb-8">
        {cs ? '6. Multi-operator provoz' : '6. Multi-operator operation'}
      </h2>
      <div className="copy prose-guide max-w-none">
        {cs ? <CsBody /> : <EnBody />}
      </div>
    </article>
  )
}
